// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1OV1p","tagName":"Tag_tagName__2a6kT","dismissContainer":"Tag_dismissContainer__1uPSu","tagDismiss":"Tag_tagDismiss__2GYe2"};